// user.action
import { authConstants, userConstants } from "./constants";
import axios from "../helpers/axios";

const emptySubscription = {
  type: "none",
  plan: "none",
  validUntil: null,
  autoRenew: false,
  status: "inactive",
  canceledAt: null,
  lastRenewalAt: null,
  nextBillingAt: null
};

const normalizeUser = (user = {}) => {
  return {
    ...user,
    balance: Number(user.balance || 0),
    subscription: {
      ...emptySubscription,
      ...(user.subscription || {})
    }
  };
};

const saveUser = (user) => {
  const normalizedUser = normalizeUser(user);
  localStorage.setItem("user", JSON.stringify(normalizedUser));

  return normalizedUser;
};

const updateAuthUser = (dispatch, user) => {
  const token = localStorage.getItem("token");
  const normalizedUser = saveUser(user);

  dispatch({
    type: authConstants.LOGIN_SUCCESS,
    payload: {
      token,
      user: normalizedUser,
    },
  });

  return normalizedUser;
};

const getErrorMessage = (error, fallback = "Ошибка запроса") => {
  return error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback;
};

export const updateCurrentUserProfile = (section, fields = {}) => {
  return async (dispatch) => {
    try {
      const res = await axios.patch("/user/profile", {
        section,
        fields,
        source: "web",
      });

      if (res.status === 200) {
        const user = res.data?.user ? updateAuthUser(dispatch, res.data.user) : null;

        return {
          ok: true,
          ...res.data,
          user,
        };
      }

      return {
        ok: false,
        message: res.data?.message || "Ошибка обновления профиля",
      };
    } catch (error) {
      return {
        ok: false,
        message: getErrorMessage(error, "Ошибка обновления профиля"),
      };
    }
  };
};

export const updateSiteThemeType = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: userConstants.USER_UPDATE_SITE_THEME_TYPE_REQUEST });

      const siteThemeType = payload?.siteThemeType === "black" ? "black" : "white";

      const res = await axios.post("/user/updateSiteThemeType", {
        siteThemeType
      });

      if (res.status === 200) {
        const user = res.data?.user ? updateAuthUser(dispatch, res.data.user) : null;

        dispatch({
          type: userConstants.USER_UPDATE_SITE_THEME_TYPE_SUCCESS,
          payload: {
            ...res.data,
            user
          },
        });

        return {
          ok: true,
          ...res.data,
          user
        };
      }

      dispatch({
        type: userConstants.USER_UPDATE_SITE_THEME_TYPE_FAILURE,
        payload: res.data,
      });

      return {
        ok: false,
        message: res.data?.message || "Ошибка обновления темы"
      };
    } catch (error) {
      const message = getErrorMessage(error, "Ошибка обновления темы");

      dispatch({
        type: userConstants.USER_UPDATE_SITE_THEME_TYPE_FAILURE,
        payload: {
          message,
          error: message,
        },
      });

      return {
        ok: false,
        message
      };
    }
  };
};

export const updateTrafficSavings = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: userConstants.USER_UPDATE_TRAFFIC_SAVING_REQUEST });

      const trafficSavings = payload?.trafficSavings !== false;

      const res = await axios.post("/user/updateTrafficSavings", {
        trafficSavings
      });

      if (res.status === 200) {
        const user = res.data?.user ? updateAuthUser(dispatch, res.data.user) : null;

        dispatch({
          type: userConstants.USER_UPDATE_TRAFFIC_SAVING_SUCCESS,
          payload: {
            ...res.data,
            user
          },
        });

        return {
          ok: true,
          ...res.data,
          user
        };
      }

      dispatch({
        type: userConstants.USER_UPDATE_TRAFFIC_SAVING_FAILURE,
        payload: res.data,
      });

      return {
        ok: false,
        message: res.data?.message || "Ошибка обновления качества фото"
      };
    } catch (error) {
      const message = getErrorMessage(error, "Ошибка обновления качества фото");

      dispatch({
        type: userConstants.USER_UPDATE_TRAFFIC_SAVING_FAILURE,
        payload: {
          message,
          error: message,
        },
      });

      return {
        ok: false,
        message
      };
    }
  };
};

export const updateNewsletterSettings = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: userConstants.USER_UPDATE_NEWSLETTER_SETTINGS_REQUEST });

      const res = await axios.post("/user/newsletter-settings", {
        weekly: payload?.weekly !== false,
        product: payload?.product !== false,
        billing: payload?.billing !== false,
        office: payload?.office !== false,
      });

      if (res.status === 200) {
        const user = res.data?.user ? updateAuthUser(dispatch, res.data.user) : null;

        dispatch({
          type: userConstants.USER_UPDATE_NEWSLETTER_SETTINGS_SUCCESS,
          payload: {
            ...res.data,
            user
          },
        });

        return {
          ok: true,
          ...res.data,
          user
        };
      }

      dispatch({
        type: userConstants.USER_UPDATE_NEWSLETTER_SETTINGS_FAILURE,
        payload: res.data,
      });

      return {
        ok: false,
        message: res.data?.message || "Ошибка обновления рассылки"
      };
    } catch (error) {
      const message = getErrorMessage(error, "Ошибка обновления рассылки");

      dispatch({
        type: userConstants.USER_UPDATE_NEWSLETTER_SETTINGS_FAILURE,
        payload: {
          message,
          error: message,
        },
      });

      return {
        ok: false,
        message
      };
    }
  };
};

export const changeCurrentUserPassword = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: userConstants.USER_CHANGE_PASSWORD_REQUEST });

      const res = await axios.post("/user/change-password/request", {
        currentPassword: payload?.currentPassword || "",
        newPassword: payload?.newPassword || "",
        confirmPassword: payload?.confirmPassword || "",
      });

      if (res.status === 200) {
        dispatch({
          type: userConstants.USER_CHANGE_PASSWORD_SUCCESS,
          payload: res.data,
        });

        return {
          ok: true,
          message: res.data?.message || "Код подтверждения отправлен на email",
          secondsLeft: res.data?.secondsLeft || 0
        };
      }

      dispatch({
        type: userConstants.USER_CHANGE_PASSWORD_FAILURE,
        payload: res.data,
      });

      return {
        ok: false,
        message: res.data?.message || "Ошибка отправки кода"
      };
    } catch (error) {
      const message = getErrorMessage(error, "Ошибка отправки кода");

      dispatch({
        type: userConstants.USER_CHANGE_PASSWORD_FAILURE,
        payload: {
          message,
          error: message,
          secondsLeft: error?.response?.data?.secondsLeft || 0
        },
      });

      return {
        ok: false,
        message,
        secondsLeft: error?.response?.data?.secondsLeft || 0
      };
    }
  };
};

export const confirmCurrentUserPasswordChange = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: userConstants.USER_CHANGE_PASSWORD_REQUEST });

      const res = await axios.post("/user/change-password/confirm", {
        code: String(payload?.code || "").trim()
      });

      if (res.status === 200) {
        dispatch({
          type: userConstants.USER_CHANGE_PASSWORD_SUCCESS,
          payload: res.data,
        });

        return {
          ok: true,
          message: res.data?.message || "Пароль успешно изменён"
        };
      }

      dispatch({
        type: userConstants.USER_CHANGE_PASSWORD_FAILURE,
        payload: res.data,
      });

      return {
        ok: false,
        message: res.data?.message || "Ошибка подтверждения смены пароля"
      };
    } catch (error) {
      const message = getErrorMessage(error, "Ошибка подтверждения смены пароля");

      dispatch({
        type: userConstants.USER_CHANGE_PASSWORD_FAILURE,
        payload: {
          message,
          error: message,
          attemptsLeft: error?.response?.data?.attemptsLeft
        },
      });

      return {
        ok: false,
        message,
        attemptsLeft: error?.response?.data?.attemptsLeft
      };
    }
  };
};

export const requestEmailChange = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: userConstants.USER_EMAIL_CHANGE_REQUEST_REQUEST });

      const res = await axios.post("/user/email-change/request", {
        email: String(payload?.email || "").trim().toLowerCase()
      });

      if (res.status === 200) {
        dispatch({
          type: userConstants.USER_EMAIL_CHANGE_REQUEST_SUCCESS,
          payload: res.data,
        });

        return {
          ok: true,
          message: res.data?.message || "Код отправлен на новый email",
          secondsLeft: res.data?.secondsLeft || 0
        };
      }

      dispatch({
        type: userConstants.USER_EMAIL_CHANGE_REQUEST_FAILURE,
        payload: res.data,
      });

      return {
        ok: false,
        message: res.data?.message || "Ошибка отправки кода"
      };
    } catch (error) {
      const message = getErrorMessage(error, "Ошибка отправки кода");

      dispatch({
        type: userConstants.USER_EMAIL_CHANGE_REQUEST_FAILURE,
        payload: {
          message,
          error: message,
          secondsLeft: error?.response?.data?.secondsLeft || 0
        },
      });

      return {
        ok: false,
        message,
        secondsLeft: error?.response?.data?.secondsLeft || 0
      };
    }
  };
};

export const confirmEmailChange = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: userConstants.USER_EMAIL_CHANGE_CONFIRM_REQUEST });

      const res = await axios.post("/user/email-change/confirm", {
        code: String(payload?.code || "").trim()
      });

      if (res.status === 200) {
        const user = res.data?.user ? updateAuthUser(dispatch, res.data.user) : null;

        dispatch({
          type: userConstants.USER_EMAIL_CHANGE_CONFIRM_SUCCESS,
          payload: {
            ...res.data,
            user
          },
        });

        return {
          ok: true,
          message: res.data?.message || "Email успешно изменён",
          user
        };
      }

      dispatch({
        type: userConstants.USER_EMAIL_CHANGE_CONFIRM_FAILURE,
        payload: res.data,
      });

      return {
        ok: false,
        message: res.data?.message || "Ошибка подтверждения email"
      };
    } catch (error) {
      const message = getErrorMessage(error, "Ошибка подтверждения email");

      dispatch({
        type: userConstants.USER_EMAIL_CHANGE_CONFIRM_FAILURE,
        payload: {
          message,
          error: message,
          attemptsLeft: error?.response?.data?.attemptsLeft
        },
      });

      return {
        ok: false,
        message,
        attemptsLeft: error?.response?.data?.attemptsLeft
      };
    }
  };
};

export const toggleSubscriptionCompletion = (subscriptionId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: userConstants.UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_REQUEST });

      const res = await axios.put(`/user/subscriptions/${subscriptionId}`);

      if (res.status === 200) {
        const user = res.data?.user ? updateAuthUser(dispatch, res.data.user) : null;

        dispatch({
          type: userConstants.UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_SUCCESS,
          payload: {
            ...res.data,
            user
          },
        });

        return {
          ok: true,
          ...res.data,
          user
        };
      }

      dispatch({
        type: userConstants.UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_FAILURE,
        payload: res.data,
      });

      return {
        ok: false,
        message: res.data?.message || "Ошибка обновления подписки"
      };
    } catch (error) {
      const message = getErrorMessage(error, "Ошибка обновления подписки");

      dispatch({
        type: userConstants.UPDATE_TOGGLE_SUBSCRIPTION_BY_ID_FAILURE,
        payload: {
          message,
          error: message,
        },
      });

      return {
        ok: false,
        message
      };
    }
  };
};

export const updateRegion = (regionId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: userConstants.UPDATE_USER_REGION_REQUEST });

      const res = await axios.patch(`/user/${regionId}`);

      if (res.status === 200) {
        const user = res.data?.user ? updateAuthUser(dispatch, res.data.user) : null;

        dispatch({
          type: userConstants.UPDATE_USER_REGION_SUCCESS,
          payload: {
            ...res.data,
            user
          },
        });

        return {
          ok: true,
          ...res.data,
          user
        };
      }

      dispatch({
        type: userConstants.UPDATE_USER_REGION_FAILURE,
        payload: res.data,
      });

      return {
        ok: false,
        message: res.data?.message || "Ошибка обновления региона"
      };
    } catch (error) {
      const message = getErrorMessage(error, "Ошибка обновления региона");

      dispatch({
        type: userConstants.UPDATE_USER_REGION_FAILURE,
        payload: {
          message,
          error: message,
        },
      });

      return {
        ok: false,
        message
      };
    }
  };
};

export const getAddress = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: userConstants.GET_USER_ADDRESS_REQUEST });

      const res = await axios.get("/user/getAddress");

      if (res && res.status === 200) {
        const {
          userAddress: { address },
        } = res.data;

        dispatch({
          type: userConstants.GET_USER_ADDRESS_SUCCESS,
          payload: { address },
        });

        return res.data;
      }

      dispatch({
        type: userConstants.GET_USER_ADDRESS_FAILURE,
      });

      return null;
    } catch (error) {
      dispatch({
        type: userConstants.GET_USER_ADDRESS_FAILURE,
        payload: {
          error: getErrorMessage(error, "Ошибка загрузки адресов"),
        },
      });

      return null;
    }
  };
};

export const addAddress = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: userConstants.ADD_USER_ADDRESS_REQUEST });

      const res = await axios.post("/user/address/create", { payload });

      if (res.status === 201) {
        const {
          address: { address },
          addressObj,
        } = res.data;

        dispatch({
          type: userConstants.ADD_USER_ADDRESS_SUCCESS,
          payload: { address, addressObj },
        });

        dispatch(getAddress());

        return res.data;
      }

      const { error } = res.data;

      dispatch({
        type: userConstants.ADD_USER_ADDRESS_FAILURE,
        payload: { error },
      });

      return res.data;
    } catch (error) {
      const message = getErrorMessage(error, "Ошибка добавления адреса");

      dispatch({
        type: userConstants.ADD_USER_ADDRESS_FAILURE,
        payload: {
          error: message,
        },
      });

      throw error;
    }
  };
};

export const subscribeEAUser = (id) => async (dispatch) => {
  try {
    const res = await axios.post(`/subscribeEAUser/${id}`);

    return res.data;
  } catch (error) {
    throw error;
  }
};
